module.exports = __webpack_public_path__ + "static/media/thewest-digital-hero-variation-footy-lives-here-guernsey.1351bbcd.jpg";